export const translations = {
  en: {
    addressInput: {
      mismatch:
        'Your address could not be verified by USPS. Please select an option below so we can ensure proper formatting for your address.',
      enteredAddressLabel: 'Entered Address:',
      suggestedAddressLabel: 'Suggested Address:',
      pickEnteredAddressCTA: 'Use entered address',
      pickSuggestedAddressCTA: 'Use suggested address',
      missingUnitError:
        'You may be missing a unit #, are you sure you want to continue?',
    },
  },
  es: {
    addressInput: {
      mismatch:
        'Su dirección no pudo ser verificada por USPS. Por favor, seleccione una opción a continuación para asegurarnos de que su dirección esté formateada correctamente.',
      enteredAddressLabel: 'Dirección ingresada:',
      suggestedAddressLabel: 'Dirección sugerida:',
      pickEnteredAddressCTA: 'Usar dirección ingresada',
      pickSuggestedAddressCTA: 'Usar dirección sugerida',
      missingUnitError:
        'Puede que le falte un número de unidad. ¿Está seguro de que desea continuar?',
    },
  },
};
